import { getUser, Users } from '../config';

const BusinessRoles = {
    Administrator: 'Administrator',
    View: 'View',
    'Financing Approver': 'Financing Approver',
    'Financing Requestor': 'Financing Requestor',
    'Operations Peers': 'Operations Peers',
    'Financing Peers': 'Financing Peers',
    Analyst: 'Analyst',
    'Operations Requestor': 'Operations Requestor',
    'Operations Approver': 'Operations Approver',
    Developer: 'Developer',
};

const BankRoles = {
    Administrator: 'Administrator',
    View: 'View',
    'Customer care': 'Customer care',
    'Product manager': 'Product manager',
    'Product owner': 'Product owner',
    'Credit operations': 'Credit operations',
    'Credit manager': 'Credit manager',
    'Risk manager': 'Risk manager',
    Analyst: 'Analyst',
    'Guarantees Approver': 'Guarantees Approver',
    'KYC Verifier': 'KYC Verifier',
    'Guarantees Verifier': 'Guarantees Verifier',
    'KYC Approver': 'KYC Approver',
    // The two halves of a trade finance decision, seeded by bank-authentication.
    'Trade Finance Verifier': 'Trade Finance Verifier',
    'Trade Finance Approver': 'Trade Finance Approver',
};

export type BusinessRolesType = keyof typeof BusinessRoles;
export type BankRolesType = keyof typeof BankRoles;

/**
 * Every role either tenant defines.
 *
 * The default export below is a runtime ternary, and `keyof` over a union of two
 * object types yields only the keys they share — which left `RolesType` as
 * `'Administrator' | 'View' | 'Analyst'` and silently untyped every other role in
 * `moduleActionRestrictions`. Naming the union here restores the checking; which
 * roles actually exist at runtime is still a tenant question, not a type one.
 */
export type AllRolesType = BusinessRolesType | BankRolesType;

export default getUser() === Users.BANK ? BankRoles : BusinessRoles;

// export default {
//     ADMINISTRATOR: 'Administrator',
//     VIEW: 'View',
//     FINANCING_APPROVER: 'Financing Approver',
//     FINANCING_REQUESTOR: 'Financing Requestor',
//     OPERATIONS_PEERS: 'Operations Peers',
//     FINANCING_PEERS: 'Financing Peers',
//     ANALYST: 'Analyst',
//     OPERATIONS_REQUESTOR: 'Operations Requestor',
//     OPERATIONS_APPROVER: 'Operations Approver',
//     DEVELOPER: 'Developer',
// };
